export default __webpack_public_path__ + "static/pic-5-b88cc22dbbd96dce33aca0707046b341.png";